import { render, staticRenderFns } from "./FormCampanaAbonos.vue?vue&type=template&id=22b8f464"
import script from "./FormCampanaAbonos.vue?vue&type=script&lang=js"
export * from "./FormCampanaAbonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports